/**
 * @generated SignedSource<<d1e90ff686635ebd82849e43dd657fc5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignerDirectoryContent_viewer$data = {
  readonly designFirms: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectoryFirmTile_firm">;
      } | null;
    } | null> | null;
    readonly totalResults: number | null;
  } | null;
  readonly regions: ReadonlyArray<{
    readonly code: string | null;
    readonly regionName: string | null;
  } | null> | null;
  readonly " $fragmentType": "DesignerDirectoryContent_viewer";
};
export type DesignerDirectoryContent_viewer$key = {
  readonly " $data"?: DesignerDirectoryContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectoryContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "pageStartOffset"
    },
    {
      "kind": "RootArgument",
      "name": "regionCodes"
    },
    {
      "kind": "RootArgument",
      "name": "resultsPerPage"
    },
    {
      "kind": "RootArgument",
      "name": "showOnlyTpnFirms"
    },
    {
      "kind": "RootArgument",
      "name": "showTestFirms"
    },
    {
      "kind": "RootArgument",
      "name": "sortBy"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignerDirectoryContent_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "resultsPerPage"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "pageStartOffset",
          "variableName": "pageStartOffset"
        },
        {
          "kind": "Variable",
          "name": "regionCodes",
          "variableName": "regionCodes"
        },
        {
          "kind": "Variable",
          "name": "showOnlyTpnFirms",
          "variableName": "showOnlyTpnFirms"
        },
        {
          "kind": "Variable",
          "name": "showTestFirms",
          "variableName": "showTestFirms"
        },
        {
          "kind": "Variable",
          "name": "sortBy",
          "variableName": "sortBy"
        }
      ],
      "concreteType": "DirectoryDesignFirmConnection",
      "kind": "LinkedField",
      "name": "designFirms",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DirectoryDesignFirmEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DirectoryDesignFirm",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DesignerDirectoryFirmTile_firm"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "regionType",
          "value": "TRADE_FIRM_REGION"
        }
      ],
      "concreteType": "Region",
      "kind": "LinkedField",
      "name": "regions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "regionName",
          "storageKey": null
        }
      ],
      "storageKey": "regions(regionType:\"TRADE_FIRM_REGION\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "818744528b864b48c5c747e54a318178";

export default node;
